import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Segment } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import { searchManyInputStyles } from '../../base/fc-search-many-input/fc-search-many-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchSegments($where: SegmentWhereInput, $limit: Int, $offset: Int) {
    segments(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
        archived
      }
    }
  }
`;

@Component({
  selector: 'fc-segments-input',
  templateUrl: './fc-segments-input.component.html',
  styleUrls: ['./fc-segments-input.component.scss']
})
export class FcSegmentsInputComponent {

  @Input()
  public control: FormControl;

  @Input()
  public shouldDisplayArchived = false;

  @Input()
  public desiredStyle: searchManyInputStyles = searchManyInputStyles.Select;

  @Input()
  public disabled = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<Segment[]> {
    const where = {
      name_contains: searchTerm,
    };

    if (!this.shouldDisplayArchived) {
      where['archived'] = false;
    }

    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where,
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => result.data['segments']['items'])
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: Segment): string {
    return value && value.name;
  }
}
